import React, { Component } from 'react'
import Meta from 'components/layout/Meta';
import {actions} from "components/page/pageModule";

import './index.scss'

class FengKong extends Component {

  constructor(props) {
    super(props)
  }

  render() {

    return (
      <div className="servicesWrap">
        <Meta location={this.props.location} title=""/>
        <div className="banner fk_banner">
          <div className="banner_cont">
            <h1>智能风控</h1>
            <p>中腾信智能风控系统集人工智能技术与业务思考于一身，贯穿消费信贷风控全流程，涵盖反欺诈平台、智能决策引擎、变量计算平台、征信平台、信贷审批系统5大产品。</p>
            <a href="./services/submitform">方案咨询</a>
          </div>
        </div>
        <div className="wrapPanel">
          <div className="panel fk_panel">
            <h2><span>风控全流程支持</span></h2>
            <img src={require('./images/pro_3.png')}/>
          </div>
        </div>
        <div className="wrapPanel panelCol">
          <div className="panel fk_panel">
            <h2><span>智能风控产品</span></h2>
            <ul>
              <li>
                <div className="img"></div>
                <p>反欺诈系统-罗网</p>
                <a href="./services/luowang">查看详情</a>
              </li>
              <li>
                <div className="img"></div>
                <p>策略引擎 – 上策</p>
                <a href="./services/shangce">查看详情</a>
              </li>
              <li>
                <div className="img"></div>
                <p>指标计算平台 – 蜂巢</p>
                <a href="./services/fengchao">查看详情</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}


export default FengKong



// WEBPACK FOOTER //
// ./modules/services/FengKong.js